import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import "./index.scss";
import { Slick } from "@/pages/vendors/vendor.slick"; // eslint-disable-next-line fht-eslint-rules/no-restricted-syntax-enhanced

import "font-awesome/css/font-awesome.css";
import { isIe8 } from "@/pages/base/ieVersion";
import { KEY_VALUES } from "@/consts";
import jqueryDataUtil from "@/common/jqueryDataUtil";
$(function () {
  var slick = new Slick($(".product-detail-modal__left-list"), {
    dots: false,
    arrows: false,
    infinite: false
  });
  $(document.body).on("click", ".preview-contain__small", function () {
    return __awaiter(this, void 0, void 0, function () {
      var createRemodal, productDetailModal;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , import("@/pages/vendors/remodal")];

          case 1:
            createRemodal = _a.sent().createRemodal;
            productDetailModal = createRemodal($('[data-remodal-id="product-detail-modal"]'));
            productDetailModal.open();

            if ($(".product-detail-thumb__item").length === 1) {
              // this product has only 1 image. force slick-track width to 100%
              $(".slick-track").css("width", "100%");
            }

            slick.slickGoTo(0);
            $(document).on("click", ".product-detail-modal__close", function () {
              productDetailModal.close();
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  });
  $(document.body).on("keyup", function (e) {
    if (e.key === KEY_VALUES.LEFT_ARROW) {
      slick.slickPrev();
    } else if (e.key === KEY_VALUES.RIGHT_ARROW) {
      slick.slickNext();
    }
  });
  slick.onAfterChange(function (event, slick, currentSlide, nextSlide) {
    $(".product-detail-modal__right-item").removeClass("product-detail-modal__right-item-active").eq(currentSlide).addClass("product-detail-modal__right-item-active");
  });
  $(".product-detail-modal__left-prev").click(function () {
    slick.slickPrev();
  });
  $(".product-detail-modal__left-next").click(function () {
    slick.slickNext();
  });
  import("@/pages/vendors/vendor.hoverIntent").then(function (_a) {
    var createHoverIntent = _a.createHoverIntent;
    createHoverIntent($(".product-detail-modal__right-item"), {
      over: function over() {
        var $this = $(this);
        if ($this.is(".product-detail-modal__right-item-active")) return;
        var index = $(".product-detail-modal__right-item").index($this);
        slick.slickGoTo(index);
      }
    });
  });
});
$(function () {
  var $previewContain = $(".preview-contain");
  var $smallImgContain = $(".preview-contain__small");
  var $smallImg = $(".preview-contain__small img");
  var $smallVideo = $(".preview-contain__small video");
  var $bigImgContain = $(".preview-contain__big");
  var $bigImg = $(".preview-contain__big img");
  var bigImgContainWidth = $bigImgContain.width();
  var bigImgContainHeight = $bigImgContain.height();
  var $smallHoverBg = $(".preview-contain__small-hover-bg");
  $(".product-detail-thumb__preview").on("click", function () {
    var $this = $(this);

    if ($this.is(".product-detail-thumb__enable")) {
      $(".product-detail-thumb__list").animate({
        left: "0"
      }, 200);
      $this.removeClass("product-detail-thumb__enable");
      $(".product-detail-thumb__next").addClass("product-detail-thumb__enable");
    }
  });
  $(".product-detail-thumb__next").on("click", function () {
    var $this = $(this);

    if ($this.is(".product-detail-thumb__enable")) {
      var left = $(".product-detail-thumb__list-contain").width();
      $(".product-detail-thumb__list").animate({
        left: -left
      }, 200);
      $this.removeClass("product-detail-thumb__enable");
      $(".product-detail-thumb__preview").addClass("product-detail-thumb__enable");
    }
  });

  function setThumbActive($dom) {
    if ($dom.length > 0) {
      var videoPath = jqueryDataUtil.optionalString($dom, "video-path");
      var smallSrc = jqueryDataUtil.requiredString($dom, "origin-src");
      var largeSrc = jqueryDataUtil.requiredString($dom, "large-src"); //$(".product-detail-thumb__item img").removeClass("product-detail-thumb__active");
      //$dom.addClass("product-detail-thumb__active");

      $(".product-detail-thumb__item").removeClass("product-detail-thumb__active");
      $dom.parent(".product-detail-thumb__item").addClass("product-detail-thumb__active");
      $bigImg.attr("src", largeSrc); //视频

      if (videoPath === undefined) {
        $smallImg.attr("src", smallSrc);
        $smallVideo.attr("src", "");
      } //图片
      else {
        $smallImg.attr("src", "");
        $smallVideo.attr("src", videoPath);
      }
    }
  }

  import("@/pages/vendors/vendor.hoverIntent").then(function (_a) {
    var createHoverIntent = _a.createHoverIntent;
    createHoverIntent($(".product-detail-thumb__item img"), {
      timeout: 50,
      interval: 50,
      over: function over() {
        var $this = $(this);
        setThumbActive($this);
      },
      out: function out() {
        return;
      }
    });
  }); //图片大于5个时，左右箭头启动

  if ($(".product-detail-thumb__item").length > 5) {
    $(".product-detail-thumb__next").addClass("product-detail-thumb__enable");
  }

  var $firstThumb = $(".product-detail-thumb__item:first-child img");
  setThumbActive($firstThumb);
  $bigImg.load(function () {
    //判断图片是否可预览
    var bigImgWidth = this.width;
    var bigImgHeight = this.height;

    if (!bigImgWidth || bigImgWidth <= bigImgContainWidth || bigImgHeight <= bigImgContainHeight) {
      $smallImgContain.addClass("disable-preview");
    } else {
      $smallImgContain.removeClass("disable-preview");
    }
  }); //小图hover事件
  //1

  $smallImgContain.mouseenter(function () {
    if ($(this).is(".disable-preview")) return;
    $smallHoverBg.show();
    $bigImgContain.show();
  }).mouseleave(function () {
    if ($(this).is(".disable-preview")) return;
    $smallHoverBg.hide();
    $bigImgContain.hide();
  }); //    2. 黄色盒子在小盒子范围内活动,鼠标在黄色盒子中间

  $smallImgContain.mousemove(function (e) {
    if ($(this).is(".disable-preview")) return; // 2.3 在事件处理函数中,获取到鼠标在可视区的坐标
    //关于坐标的加个参数
    //https://www.cnblogs.com/jiangxiaobo/p/6593584.html
    // const x = e.clientX; clientX 兼容最好
    // const y = e.clientY;

    var mouseX = 0;
    var mouseY = 0;

    if (isIe8()) {
      mouseX = e.clientX;
      mouseY = e.clientY;
    } else {
      mouseX = e.pageX;
      mouseY = e.pageY;
    } //        2.4 在事件处理函数中,获取box相对于body的左,上偏移量


    var offLeft = $previewContain.offset().left;
    var offTop = $previewContain.offset().top; //        2.2 计算鼠标在small里面的坐标(即mask移动的距离)  可视区坐标 - box的偏移量

    var targetX = mouseX - offLeft;
    var targetY = mouseY - offTop; //
    //        2.6 让鼠标到mask中间(其实是mask在鼠标坐标的基础上,往左,往上,自己宽高的一半)

    targetX -= $smallHoverBg.width() / 2;
    targetY -= $smallHoverBg.height() / 2; //        2.7 限制mask的位置
    //              2.7.1 获取最大,最小距离

    var maxX = $smallImgContain.width() - $smallHoverBg.width(); //small的宽 - mask的宽

    var maxY = $smallImgContain.height() - $smallHoverBg.height(); //small的宽 - mask的宽
    //              2.7.2 判断有没有超出最大/最小距离

    targetX = targetX < 0 ? 0 : targetX;
    targetX = targetX > maxX ? maxX : targetX;
    targetY = targetY < 0 ? 0 : targetY;
    targetY = targetY > maxY ? maxY : targetY; //        2.5 给mask赋值,渲染

    $smallHoverBg.css({
      left: targetX,
      top: targetY
    }); //        3. 黄色盒子覆盖到哪里,对应的大盒子里图片展示哪里
    //              mask移动的距离 / mask移动的最大距离 == img移动的距离 / img移动的最大距离
    //
    //              img移动的距离 = mask移动的距离 / mask移动的最大距离 * img移动的最大距离
    //              3.1 计算img移动的最大距离  img的宽 - big的宽

    var imgMaxX = $bigImg.width() - $bigImgContain.width();
    var imgMaxY = $bigImg.height() - $bigImgContain.height(); //              3.2 根据公式计算img应该移动多少

    var imgX = targetX / maxX * imgMaxX;
    var imgY = targetY / maxY * imgMaxY; //              3.3 给img赋值,负值

    $bigImg.css({
      left: -imgX,
      top: -imgY
    });
  });
});